<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
     {{data_id.name}}
    </v-card-title>
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="modalOpenAddFormList"
            >
              Add Type
            </v-btn>
            <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      loading-text="Loading... Please wait"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >
    
     <template v-slot:[`item.vehicle_fuel_type`]="{ item }">
      <span v-if="item.vehicle_fuel_type == 1">Bensin</span>
      <span v-if="item.vehicle_fuel_type == 2">Diesel</span>
      <span v-if="item.vehicle_fuel_type == 3">Listrik</span>
      <span v-if="item.vehicle_fuel_type == 4">Hybrid</span>
      <span v-if="item.vehicle_fuel_type == 5">CNG</span>
     </template>
    
     <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="modalOpenEditFormType(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
      >
        mdi-delete
      </v-icon>
    </template>
    
    </v-data-table>
  </v-card>
  <modal ref="modalFormType">
            <template v-slot:header>
              <h3>{{ titleFormType }}</h3>
            </template>

            <template v-slot:body>
             <form ref="add_vehicle_type_form" @submit.prevent="submitFormType">

                  <md-card>

                    <md-card-header class="md-card-header-icon">
                      <div class="card-icon">
                        <md-icon>perm_identity</md-icon>
                      </div>
                      <!-- <h4 class="title">
                        Add Spare Part Master
                      </h4> -->
                    </md-card-header>
                    <md-card-content class="m-5">
                       <input v-model="id" :readonly="true" type="hidden"/>            

                       <div v-if="vehicle_no" class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Vehicle No
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input v-model="vehicle_no" readonly/>
                            <validation-error :errors="apiValidationErrors.vehicle_no" />
                          </md-field>
                        </div>
                      </div> 

                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Vehicle Type/Model
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input v-model="vehicle_type" />
                            <validation-error :errors="apiValidationErrors.vehicle_model" />
                          </md-field>
                        </div>
                      </div>

                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Year Model
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input type="text" v-on:keypress="NumbersOnly" v-model="vehicle_year_model" />
                            <validation-error :errors="apiValidationErrors.vehicle_year_model" />
                          </md-field>
                        </div>
                      </div>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Fuel type
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-select v-model="vehicle_fuel_type" required>
                              <md-option value="0">Bensil</md-option>
                              <md-option value="1">Solar</md-option>
                              <md-option value="2">Listrik</md-option>
                            </md-select>
                            <validation-error :errors="apiValidationErrors.vehicle_fuel_type" />
                          </md-field>
                        </div>
                      </div>
                      <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                          Cylinder capacity
                        </label>
                        <div class="md-layout-item">
                          <md-field class="md-invalid">
                            <md-input type="text" v-on:keypress="NumbersOnly" v-model="vehicle_cylinder_capacity" />
                            <validation-error :errors="apiValidationErrors.vehicle_cylinder_capacity"  />
                          </md-field>
                        </div>
                      </div>

                    </md-card-content>

                    <md-card-actions>
                      <md-button type="submit">
                        submit
                      </md-button>
                    </md-card-actions>
                  </md-card>

                </form>
            </template>

            <template v-slot:footer>
              <md-card-actions>
                <md-button @click="modalCloseFormType">
                  Close
                </md-button>
              </md-card-actions>
            </template>
        </modal>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import { Modal } from "@/components";
import JsonExcel from "vue-json-excel";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {
    Modal,"downloadExcel" :JsonExcel,ValidationError,ResizablePage
  },
  mixins: [formMixin],
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        role: "",
        search: '',
        headers: [
          {
            text: 'Vehicle No.',
            align: 'start',
            value: 'vehicle_no',
          },
          { text: 'Type', value: 'vehicle_model'},
          { text: 'Year Model', value: 'vehicle_year_model'},
          { text: 'Fule Type', value: 'vehicle_fuel_type'},
          { text: 'Cylinder capacity', value: 'vehicle_cylinder_capacity'},
          { text: 'Updated At', value: 'updated_at', align: 'center'},
          { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
        ],
        table: [],
        
        worksheetName: "Spare Part Master",
        fileName:"Spare Part Master.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
          'no' : 'no',
          'vehicle_model' : 'vehicle_model',
          'vehicle_year_model' : 'vehicle_year_model',
          'vehicle_fuel_type' : 'vehicle_fuel_type',
          'vehicle_cylinder_capacity' : 'vehicle_cylinder_capacity',
          created_at: "created_at",
          updated_at: "updated_at",
        },
        titleFormType: "Add Type",
        id: null,
        vehicle_no: null,
        vehicle_type: null,
        vehicle_year_model: null,
        vehicle_fuel_type: null,
        vehicle_cylinder_capacity: null,
        vehicle_brand_id: null,
        options_brand: null,
      }
    },
    async created() {
      
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      
      await this.$store.dispatch("workshop_vehicle_type/listByBrand", this.data_id.id)
      if (Object.keys(await this.$store.getters["workshop_vehicle_type/vehicle_type"]).length != 0) {
        this.table = await this.$store.getters["workshop_vehicle_type/vehicle_type"]
      }
      else{
        this.table = []
      }
      this.worksheetName = "List Vehicle Type " + this.data_id.name
      this.fileName = "List Vehicle Type " + this.data_id.name +'.xls'
      this.loadTable= false
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    getFiltered(data){
    this.exportDisplayedPage =  this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered =  this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered =  this.dataExport(this.table)
    }
    },

  

    async modalOpenAddFormList() {
      this.titleFormType= "Add Type"
      this.resetForm()

      this.$refs.modalFormType.openModal()
    },
    async modalOpenEditFormType(item) {
      this.titleFormType= "Edit Type"

      this.id= item.id
      this.vehicle_brand_id= item.vehicle_brand_id
      this.vehicle_no= item.vehicle_no
      this.vehicle_type= item.vehicle_model
      this.vehicle_year_model= item.vehicle_year_model
      this.vehicle_fuel_type= item.vehicle_fuel_type
      this.vehicle_cylinder_capacity= item.vehicle_cylinder_capacity
      this.$refs.modalFormType.openModal()
    },

   

    // fungsi untuk menutup pop up modal
    modalCloseFormType(){ 
      this.$refs.modalFormType.closeModal()
    },

    async submitFormType() {
      if(this.id==null){
        const data = {
            type: "workshop_vehicle_types", 
            vehicle_brand_id: this.data_id.id,
            vehicle_model: this.vehicle_type,
            vehicle_year_model: this.vehicle_year_model,
            vehicle_fuel_type: this.vehicle_fuel_type,
            vehicle_cylinder_capacity: this.vehicle_cylinder_capacity
          }


          try {
          await this.$store.dispatch("workshop_vehicle_type/add", data);
          await this.$store.dispatch(
            "alerts/success",
            "Successfully registered."
          );
          //this.table.push(await this.$store.getters["workshop_vehicle_type/vehicle_type"])
          this.$refs['add_vehicle_type_form'].reset();
          this.resetForm()
          this.modalCloseFormType()
           this.getList();
          // await this.$parent.$parent.modalCloseList()
          // await this.$parent.$parent.modalOpenList(this.data_id.id,this.data_id.name)
          } catch (e) {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong"
            );
            this.setApiValidation(e.response.data.errors);
          }
    }
    else{
        const data = {
            type: "workshop_vehicle_types", 
            id: this.id,
            //spare_part_price_master_id: this.data_id.id,
            vehicle_model: this.vehicle_type,
            vehicle_brand_id: this.vehicle_brand_id,
            vehicle_year_model: this.vehicle_year_model,
            vehicle_fuel_type: this.vehicle_fuel_type,
            vehicle_cylinder_capacity: this.vehicle_cylinder_capacity
          }


          try {
          await this.$store.dispatch("workshop_vehicle_type/update", data);
          await this.$store.dispatch(
            "alerts/success",
            "Successfully registered."
          );
          // var indexOption = this.table.findIndex(p => p.id ==  this.id)
          // //this.table[indexOption] = await this.$store.getters["workshop_spare_part_price/spare_part_price"]

          // var indexOptionDealer = this.options_dealer.findIndex(p => p.id ==  this.spare_part_price_dealer_id)
          // this.table[indexOption].spare_part_price_dealer_id = this.spare_part_price_dealer_id
          // this.table[indexOption].spare_part_price_dealer_name = this.options_dealer[indexOptionDealer].dealer_name
          // this.table[indexOption].spare_part_price_minimum_order_quantity =  this.spare_part_price_minimum_order_quantity
          // this.table[indexOption].spare_part_price_price = this.spare_part_price_price
          // console.log(this.options_dealer[indexOptionDealer].dealer_name)

          this.$refs['add_vehicle_type_form'].reset();
          this.resetForm()
          this.modalCloseFormType()
           this.getList();
          // await this.$parent.$parent.modalCloseList()
          // await this.$parent.$parent.modalOpenList(this.data_id.id,this.data_id.name)
          } catch (e) {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong"
            );
            this.setApiValidation(e.response.data.errors);
          }
    }
    },
    resetForm() {
      this.id= null
    this.vehicle_no= null
    this.vehicle_type= null
    this.vehicle_brand_id= null
    this.vehicle_year_model= null
    this.vehicle_fuel_type= null
    this.vehicle_cylinder_capacity= null
    },


    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },
  
     // fungsi delete
    async deleteData(id) {
      try {
        await this.$store.dispatch("workshop_vehicle_type/destroy", id)
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle Type data delete successfully."
        );
        var indexOptionTable = this.table.findIndex(
          (p) => p.id == id
        );
        this.table.splice(indexOptionTable, 1);
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
       //return data.map((v,index) => ({...v, no: index+1}))
       var dataOlah= []
        data.forEach((value, index) => {
                    


                    var fuel_type=''
                    if(value.vehicle_fuel_type == 1){
                        fuel_type = "Bensin"
                    }
                    else if(value.vehicle_fuel_type == 2){
                        fuel_type = "Diesel"
                    }
                    else if(value.vehicle_fuel_type == 3){
                        fuel_type = "Listrik"
                    }
                    else if(value.vehicle_fuel_type == 4){
                        fuel_type = "Hybrid"
                    }
                    else if(value.vehicle_fuel_type == 5){
                        fuel_type = "CNG"
                    }
                    
           var dataOlah2 = {
                    'no': index+1,
                     'vehicle_model' : value.vehicle_model,
                     'vehicle_year_model' : value.vehicle_year_model,
                     'vehicle_fuel_type' : fuel_type,
                     'vehicle_cylinder_capacity' : value.vehicle_cylinder_capacity,
                    'created_at' : value.created_at,
                    'updated_at' : value.updated_at
                    }
                    dataOlah.push(dataOlah2)
            });
            return dataOlah
     
      }

     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
</style>